import { customStorage } from "@/hooks/CustomLocalStorage";
import { getEnvs } from "@/shared/lib/utils";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";
// import Cookies from "js-cookie";

const { PDMG_API_URL } = getEnvs();

export const apiFetchBaseQuery = fetchBaseQuery({
	baseUrl: PDMG_API_URL,
	prepareHeaders: headers => {
		// sessionStorage.getItem("access_token")
		// Fetch tokens and other data
		const accessToken = customStorage.getItem<string>("access_token");
		if (accessToken) {
			headers.set("Authorization", `Bearer ${accessToken}`);
		}

		const apiRefreshToken = customStorage.getItem<string>("api_refresh_token");
		if (apiRefreshToken) {
			headers.set("X-Api-Refresh-Token", apiRefreshToken);
		}

		const agentId = customStorage.getItem<string>("agent_id");
		if (agentId) {
			headers.set("X-Api-Agent-Id", agentId);
		}

		return headers;
	},
});
